import { render, staticRenderFns } from "./ShopChatView.vue?vue&type=template&id=46b16cdf&scoped=true"
import script from "./ShopChatView.vue?vue&type=script&lang=js"
export * from "./ShopChatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b16cdf",
  null
  
)

export default component.exports